// extracted by mini-css-extract-plugin
export default {"bar":"style_bar__I-NSK"};